import * as XLSX from 'xlsx';

/**
 * Read Excel file and convert to JSON
 * @param {File} file - Excel file
 * @returns {Promise<Array>} - Array of row objects
 */
export async function readExcelFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Get first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          raw: false, // Get formatted strings instead of raw values
          defval: '', // Default value for empty cells
        });

        resolve(jsonData);
      } catch (error) {
        reject(new Error('ไม่สามารถอ่านไฟล์ Excel ได้: ' + error.message));
      }
    };

    reader.onerror = () => {
      reject(new Error('เกิดข้อผิดพลาดในการอ่านไฟล์'));
    };

    reader.readAsArrayBuffer(file);
  });
}

/**
 * Validate Excel file
 * @param {File} file - Excel file
 * @returns {Object} - { valid: boolean, error: string }
 */
export function validateExcelFile(file) {
  if (!file) {
    return { valid: false, error: 'กรุณาเลือกไฟล์' };
  }

  const fileName = file.name.toLowerCase();
  if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
    return { valid: false, error: 'กรุณาเลือกไฟล์ Excel (.xlsx หรือ .xls)' };
  }

  // Check file size (max 10MB)
  const maxSize = 10 * 1024 * 1024;
  if (file.size > maxSize) {
    return { valid: false, error: 'ขนาดไฟล์ต้องไม่เกิน 10 MB' };
  }

  return { valid: true, error: '' };
}

export default {
  readExcelFile,
  validateExcelFile,
};
